import { useFormatPrice } from 'hooks/formatting/useFormatPrice';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { TescomaClubIcon } from 'public/svg/IconsSvg';
import { memo } from 'react';
import { twJoin } from 'tailwind-merge';
import { ProductPricesType, ProductPriceType } from 'types/price';

type ClubPriceInfoProps = {
    price: ProductPriceType;
    prices: ProductPricesType;
    isVatAndTransportInfoRequired: boolean;
};

export const ClubPriceInfo = memo<ClubPriceInfoProps>(({ price, prices, isVatAndTransportInfoRequired = false }) => {
    const t = useTypedTranslationFunction();
    const formatPrice = useFormatPrice();

    if (prices.tescoma && prices.tescoma.priceWithVat < price.priceWithVat) {
        return (
            <small
                className={twJoin(
                    'block text-small text-red vl:ml-5 vl:inline-block',
                    isVatAndTransportInfoRequired && 'w-full vl:ml-0 vl:block',
                )}
            >
                {`${t('Price for members')} `}
                {formatPrice(prices.tescoma.priceWithVat)}
                <TescomaClubIcon className="-mt-1 ml-1 h-4 w-4 text-red" />
            </small>
        );
    }

    return null;
});

ClubPriceInfo.displayName = 'ClubPriceInfo';
